import React, {Fragment} from "react";

export default function InputKpiView({
                                         elemento,
                                         getCampoInput
                                 }) {

    return (
        <Fragment>
            {
                elemento &&
                <Fragment>
                    {
                        getCampoInput()
                    }
                </Fragment>
            }
        </Fragment>
    );
}